function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: center;\n  background: ",
        ";\n  border-bottom: 1px solid ",
        ";\n  display: flex;\n  padding: 12px 24px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: center;\n  flex: 1;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  flex-direction: column;\n  max-height: 90vh;\n  overflow-y: auto;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  overflow: hidden;\n  background: ",
        ";\n  box-shadow: 0px 20px 36px -8px rgba(14, 14, 44, 0.1), 0px 1px 1px rgba(0, 0, 0, 0.05);\n  border: 1px solid ",
        ";\n  border-radius: 32px;\n  width: 100%;\n  max-height: 100vh;\n  z-index: ",
        ";\n\n  ",
        " {\n    width: auto;\n    min-width: ",
        ";\n    max-width: 100%;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import Flex from "../../components/Box/Flex";
import { Box } from "../../components/Box";
import { ArrowBackIcon, CloseIcon } from "../../components/Svg";
import { IconButton } from "../../components/Button";
export var ModalHeader = styled.div.attrs({
    "data-ui": "modal-header"
}).withConfig({
    componentId: "sc-37e005b7-0"
})(_templateObject(), function(param) {
    var background = param.background;
    return background || "transparent";
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
export var ModalTitle = styled(Flex).withConfig({
    componentId: "sc-37e005b7-1"
})(_templateObject1());
export var ModalBody = styled(Flex).attrs({
    "data-ui": "modal-body"
}).withConfig({
    componentId: "sc-37e005b7-2"
})(_templateObject2());
export var ModalCloseButton = function(param) {
    var onDismiss = param.onDismiss;
    return /*#__PURE__*/ _jsx(IconButton, {
        variant: "text",
        onClick: onDismiss,
        "aria-label": "Close the dialog",
        children: /*#__PURE__*/ _jsx(CloseIcon, {
            color: "primary"
        })
    });
};
export var ModalBackButton = function(param) {
    var onBack = param.onBack;
    return /*#__PURE__*/ _jsx(IconButton, {
        variant: "text",
        onClick: onBack,
        "aria-label": "go back",
        mr: "8px",
        children: /*#__PURE__*/ _jsx(ArrowBackIcon, {
            color: "primary"
        })
    });
};
export var ModalContainer = styled(Box).attrs({
    "data-ui": "modal",
    role: "dialog",
    "aria-modal": true
}).withConfig({
    componentId: "sc-37e005b7-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.modal.background;
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.zIndices.modal;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xs;
}, function(param) {
    var minWidth = param.minWidth;
    return minWidth;
});
